import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import { ReactNode } from 'react';
import LangEnum from '../../../../../../../lang/LangEnum';
import useTeceoStyles from '../../../../../../../useTeceoStyles';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import { CATALOG_DETAILS_EMPTY_VALUE } from '../catalogDetailsPanel.utils';

interface CatalogDetailFieldProps {
  label: LangEnum;
  maxWidth: number | string;
  width?: number | string;
  value?: ReactNode;
  control?: ReactNode;
  labelTextColor?: 'text.primary' | 'text.secondary';
}

const CatalogDetailField = ({
  label,
  width,
  maxWidth,
  value,
  control,
  labelTextColor = 'text.secondary',
}: CatalogDetailFieldProps) => {
  const { translate } = useTranslation();
  const { classes: teceoClasses } = useTeceoStyles();
  const translatedLabel = translate(label);

  return (
    <Stack direction="row" sx={{ gap: 1, alignItems: 'flex-start' }}>
      <Box
        sx={{
          maxWidth,
          width,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          alignSelf: 'stretch',
        }}
      >
        <Typography variant="micro1" noWrap sx={{ display: 'block', color: labelTextColor }}>
          {translatedLabel}
        </Typography>
      </Box>
      {control ? (
        <Box sx={{ flex: 1, minWidth: 0 }}>{control}</Box>
      ) : (
        <Typography
          variant="body2"
          component="div"
          sx={{ flex: 1, minWidth: 0, color: 'text.primary' }}
          className={teceoClasses.truncateOneLine}
        >
          {value ?? CATALOG_DETAILS_EMPTY_VALUE}
        </Typography>
      )}
    </Stack>
  );
};

export default CatalogDetailField;
